// Auto-generated from .env.development by scripts/write-api-host.mjs — do not edit, do not commit.
export const API_BASE_URL = 'https://api.agrosmart.gov.kg';
